<template>
    <v-layout align-center justify-center>
      <v-flex xs6 sm4 md3>
        <p class="title text-xs-center"> Dollor Value </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="value"
            :rules="[v => !!v || 'Rupee value is required']"
            label="Rupee Value"
            required
          ></v-text-field>
          <v-btn @click="clear">clear</v-btn>
          <v-btn
            color="primary"
            :disabled="!valid"
            @click="submit"
          >
            submit
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
  import axios from 'axios'
  import { SERVER_URL } from './../../constant.js'

  export default {
    data: () => ({
      valid: true,
      value: 0
    }),
    created () {
      document.title = 'Setting';
      axios.get(`${SERVER_URL}/setting/dollar`).then(val => {
        this.value = val.data.value;
      })
    },
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          axios.post(`${SERVER_URL}/setting/dollar`, {
            value: this.value
          }).then(res => {
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Dollar Settings Updated Successfully'})
            document.dispatchEvent(showSnackbarEvent)
            this.$refs.form.reset()
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/setting/Dollar.vue